// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","wrapper":"faqSection_wrapper__RDJ0B","wrapper__text":"faqSection_wrapper__text__jX_m9"};